import styled from 'styled-components';
import bgImg from '../../images/about_bg.jpg';

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 500px;
  margin: 0 auto;
  background-image: url(${bgImg});
  background-size: cover;
  .about-page-row {
    position: relative;
    max-width: ${props => props.theme.maxWidth};
    margin: auto;
    background: rgba(255, 255, 255, 0.9);
    padding: 1em;
    border-radius: 20px;
    left: ${props => props.viewable ? 0 : -100 }%;
    transition: left 0.8s ease;
  }
  .about-page-col {
    padding: 20px;
    h3 {
      font-size: 1.4em;
       margin: 0;
       font-weight: 400;
    }
  }
  img {
    width: 100px;
    margin: auto;
    display: block;
  }
`;

export const Title = styled.h1`
  font-size: 1.2em;
  font-weight: 300;
  margin: 0 auto;
  padding: 4.5em 1em 1em;
  max-width: ${props => props.theme.maxWidth};
  @media (min-width: 768px) {
    font-size: 2.25em;
  }
`;



// WEBPACK FOOTER //
// ./src/components/AboutPage/Styles.js